import type { ProjectTableItem } from "@kontextwerk/control-web-client"

const DEFAULT_CHAT_WIDGET_PROJECT_NAME = "kehrblatt-chat-external"

const normalizeProjectName = (value: unknown): string | null => {
  if (typeof value !== "string") return null

  const normalized = value.trim().toLowerCase()

  return normalized.length > 0 ? normalized : null
}

const projectNameCandidates = (project: ProjectTableItem): string[] => {
  const graph = project.graph ?? null

  return [
    normalizeProjectName(graph?.project_name),
    normalizeProjectName(project.graph_slug),
    normalizeProjectName(project.slug),
    normalizeProjectName(project.name),
  ].filter((value): value is string => Boolean(value))
}

const isDefaultChatWidgetProject = (project: ProjectTableItem) =>
  projectNameCandidates(project).includes(DEFAULT_CHAT_WIDGET_PROJECT_NAME)

export const resolvePlanningChatWidgetProject = (
  projects: ProjectTableItem[] | null | undefined,
): ProjectTableItem | null => {
  const candidates = Array.isArray(projects) ? projects : []

  return (
    candidates.find(isDefaultChatWidgetProject) ??
    candidates.find((candidate) => candidate.graph?.type === "chatbot") ??
    null
  )
}
